
import { Menu } from '@headlessui/react';
import * as R from 'ramda';
import React, { useEffect, useState } from 'react';
import CommonModal from '../../models/common-modal';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { selectCurrent } from '../../redux/settings/selectors';
import { settings } from '../../redux/settings/actions';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { CancelReasonComponents } from './cancel-reasons.component';
import { PaymentStatusActionComponent } from './payment-status-action.component';
import { FulfillmentOrderStatusComponents } from './fulfillment-order-status.component';
import { cancelReasons } from '../../redux/cancel-reasons/action';
import { selectCancelReasonsListItems } from '../../redux/cancel-reasons/selector';


export function LibraryRendererComponent({ onFulfillmentOrderStatusSubmit,isFulifllmentOrderEditble,onOrderStatusClick, onPaymentStatusClick, onFullfillmentStatusSubmit, onShippingStatusClick, onReturnRequestStatusClick, value, cellRendererParams, data, dataId,cellRenderer }: any) {
  const [
    libraryElement,
    setLibraryElement
  ] = useState<any>([]);
  const [isCancel, setIsCancel] = useState<boolean>(false)
  const [isPayment, setIsPayment] = useState<boolean>(false)
  const [
    paymentValues,
    setPaymentValues
  ] = useState<any>();
  const [
    fulfillmentOrderStatus,
    setFulfillmentOrderStatus
  ] = useState<any>();
  const [
    anchorFullfillmentEl,
    setAnchorFullfillmentEl
  ] = React.useState(null);
  const [
    anchorReturnRequestEl,
    setAnchorReturnRequestEl
  ] = React.useState(null)
  const [
    anchorShipmentEl,
    setAnchorShipmentEl
  ] = React.useState(null);
  const [
    anchorOrderEl,
    setAnchorOrderEl
  ] = React.useState(null);
  const cancelitemsData = useSelector(selectCancelReasonsListItems)
  const { getCommonModal } = useAppSelector(selectCurrent)
  const handleShipmentSubmit = (event: any) => {
    onShippingStatusClick(
      event,
      dataId
    )
    handleMenuClose()
  }

  const handleMenuClose = () => {
    setAnchorReturnRequestEl(null)
    setAnchorOrderEl(null)
    setAnchorShipmentEl(null)
    setAnchorFullfillmentEl(null)
  };
  const handleOrderSubmit = (event: any) => {
    onOrderStatusClick(
      event,
      dataId
    )
    handleMenuClose()
  }
  const handleShippingSubmit = (event: any) => {
    onShippingStatusClick(
      event,
      dataId
    )
    handleMenuClose()
  }
  const handleFullfillmentSubmit = (event: any) => {
    onFullfillmentStatusSubmit(
      event,
      dataId
    )
    handleMenuClose()
  }

  const handleReturnRequestSubmit = (event: any) => {
    onReturnRequestStatusClick(
      event,
      dataId
    )
    handleMenuClose()
  }
  const [
    open,
    setOpen
  ] = React.useState(false);
  const dispatch = useAppDispatch()
  const [
    selectedValue,
    setSelectedValue
  ] = useState<any>();
  const paymentLibrary = [
    { Disabled: false, Selected: false, Text: 'Pending', Description: 'Pending', Value: 10 },
    { Disabled: false, Selected: false, Text: 'Paid', Description: 'Paid', Value: 30 },
    { Disabled: false, Selected: false, Text: 'PartiallyPaid', Description: 'PartiallyPaid', Value: 35 }
  ]

  const handleClose = () => {
    setOpen(false);

  };
  const handleFulifllmentOrderEditbleOpen = async () => {
    
   await dispatch(settings.set({ getCommonModal: 'open' }))

    await  dispatch(cancelReasons.list({url:`https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/dom/cancel-reasons/list`,entity:'cancelReasons',jsonData:{
        
      Filters: [
        {
          FieldName: 'CanceledBy',
          FilterOperatorId: 6,
          FieldValue: 30,
          FieldType: 'text'
        }
      ]
      
  
      }}))
    
  }
  const handlePaymentEditbleOpen = async () => {
    await setIsPayment(true)
    await dispatch(settings.set({ getCommonModal: 'open' }))    
   }
 
  const handleRejectOpen = async () => {
    await setIsCancel(true)
   await  dispatch(settings.set({ getCommonModal: 'open' }))
  
    await dispatch(cancelReasons.list({url:`https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/dom/cancel-reasons/list`,entity:'cancelReasons',jsonData:{
      
    Filters: [
      {
        FieldName: 'CanceledBy',
        FilterOperatorId: 6,
        FieldValue: 30,
        FieldType: 'text'
      }
    ]
    

    }}))

  };

  const handleFulfillmentOrderSubmit = () => {
    const resonDesription: any = _.filter(
      cancelitemsData?.result?.items,
      { Code: fulfillmentOrderStatus?.Code }

    );
    fulfillmentOrderStatus.Description = resonDesription[0]?.Reason;
    onFulfillmentOrderStatusSubmit(
      fulfillmentOrderStatus,
      dataId
    )

    handleFulfillmentOrderStatusClose()
    setFulfillmentOrderStatus({})
  }

  useEffect(
    () => {
      if (cellRendererParams?.library) {
        const libraryData: any = R.find(
          (requestType: any) => parseInt(
            requestType.Value,
            10
          ) === parseInt(
            value,
            10
          ),
          cellRendererParams?.library
        )
        setLibraryElement(libraryData ? libraryData.Text : '')
      }

    },
    [
      libraryElement,
      value
    ]
  );


 
  const getRandomTextColor =()=>{
    const red = Math.floor(Math.random() * 128);
const green = Math.floor(Math.random() * 128);
const blue = Math.floor(Math.random() * 128);
const hexRed = red.toString(16).padStart(2, "0");
const hexGreen = green.toString(16).padStart(2, "0");
const hexBlue = blue.toString(16).padStart(2, "0");

const hexCode = `#${hexRed}${hexGreen}${hexBlue}`;
return hexCode;
}
const randomColor = getRandomTextColor();

const onFormChange: any = ({ field, value }: any) => {
  setSelectedValue({ ...selectedValue, [field]: value })
}
const handleCancelation = () => {
  return (
    <CancelReasonComponents
    cancelreason={cancelitemsData?.result?.items}
    onFormChange={onFormChange}
    selectedValue={selectedValue}
    />
  );
};
const handlePayment = () => {
  return (
    <PaymentStatusActionComponent
    value={value}
    onPaymentFormChange={onPaymentFormChange}
    dataId={dataId}
    paymentValues={paymentValues}
    paymentLibrary={paymentLibrary}
    />
  );
};
const handleCancelationClose=()=>{
  setSelectedValue({})
  dispatch(settings.set({ getCommonModal: 'close' }))
} 

const handlePaymentClose=()=>{
  setPaymentValues({})
  dispatch(settings.set({ getCommonModal: 'close' }))
  window.location.reload();
} 
const onPaymentFormChange: any = ({ field, fieldValue }: any) => {
  setPaymentValues({ ...paymentValues, [field]: fieldValue })
}
const onFulfillmentFormChange: any = ({ field, fieldValue }: any) => {
  setFulfillmentOrderStatus({ ...fulfillmentOrderStatus, [field]: fieldValue })
}
const handleFulfillmentOrderStatus = () => {
  return (
    <FulfillmentOrderStatusComponents
    cancelreason={cancelitemsData?.result?.items}
    onFulfillmentFormChange={onFulfillmentFormChange}
  dataId={dataId}
  fulfillmentOrderStatus={fulfillmentOrderStatus}
    />
  );
};
const handleFulfillmentOrderStatusClose=()=>{
  setFulfillmentOrderStatus({})
  dispatch(settings.set({ getCommonModal: 'close' }))
} 
const handleOrderCancelSubmit = () => {
  if(data?.isOrderEditable){
  onOrderStatusClick(
    -10,
    dataId,
    selectedValue?.Code
  )}else if(data?.isVendorShipmentEditable){
    onShippingStatusClick(
      -10,
    dataId,
    selectedValue?.Code
    )
  }

  handleCancelationClose()
  setSelectedValue({})

}
const handlePaymentSubmit = () => {
  onPaymentStatusClick(
    paymentValues,
    dataId
  )

  handlePaymentClose()
  setPaymentValues({})
}

  return (
    <>
  <div>

      
      { !isPayment && !isCancel && data?.isFulifllmentOrderEditble && getCommonModal == 'open' && <CommonModal title='Update Fulfillment Order Status' renderForm={handleFulfillmentOrderStatus} 
   onSubmit={handleFulfillmentOrderSubmit} 
   handleClose={handleFulfillmentOrderStatusClose} 
   />}
{ !isPayment && isCancel && getCommonModal == 'open' &&  <CommonModal title='Cancel Confirmation' renderForm={handleCancelation} 
     onSubmit={handleOrderCancelSubmit} 
     handleClose={handleCancelationClose} 
     />}
     { isPayment && !isCancel &&  data?.isPaymentEditble && getCommonModal == 'open' &&  <CommonModal title='Update Payment Status' renderForm={handlePayment} 
     onSubmit={handlePaymentSubmit} 
     handleClose={handlePaymentClose} 
     />}

  
  </div>
    
      <div>
        {!data?.isVendorShipmentEditable && !data?.isPaymentEditble && !data?.isFulifllmentOrderEditble && !data?.isShipmentEditable && !data?.isOrderEditable && !data?.isShippingEditable && !data?.isPaymentEditble && !data?.isReturnRequestEditble && !data?.isOrderFulfillment && <span
          className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 bg-${randomColor} text-white`}
          style={{ backgroundColor: randomColor }}>

          {libraryElement || null}
        </span>}
        {data?.isFulifllmentOrderEditble ? <><span
        onClick={() => {
                        handleFulifllmentOrderEditbleOpen()
                       
                      }}
          className='p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white'
          style={{ backgroundColor: randomColor }}>

CancelledItem
        </span></>         
          : null}
          {data?.isPaymentEditble ? <><span
        onClick={() => {
                        handlePaymentEditbleOpen()
                       
                      }}
          className='p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300  text-white'
          style={{ backgroundColor: randomColor }}>

{libraryElement || null}
        </span></>         
          : null}
        {data?.isOrderEditable
          ? <>
        	<Menu as="div" className="relative text-left ">
								<div>
									<Menu.Button onClick={(e: any) => setAnchorOrderEl(e.currentTarget)} 
                  className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white `}
                  style={{ backgroundColor: getRandomTextColor() }}>
                  {libraryElement || null}
									</Menu.Button>
								</div>
                {anchorOrderEl && (
								<Menu.Items className="absolute fixed z-10 bg-white border border-gray-300 rounded shadow-lg w-auto p-1">
									<div className="px-1 py-1 ">
										<Menu.Item>
											<button 
                      onClick={() => {
                        handleOrderSubmit(20);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Accept
											</button>
										</Menu.Item>
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleRejectOpen()
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Reject
											</button>
										</Menu.Item>
              
									</div>
								</Menu.Items>
                  )}
							</Menu>
          </>
          : null}
        {data?.isShippingEditable
          ? <>
          	<Menu as="div" className="relative  text-left">
								<div>
									<Menu.Button onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)} 
                   className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white bg-${randomColor}`}
                  style={{ backgroundColor: randomColor }}>
                  {libraryElement || null}
									</Menu.Button>
								</div>
                {anchorShipmentEl && (
								<Menu.Items className="absolute fixed z-10 bg-white border border-gray-300 rounded shadow-lg w-auto p-1">
									<div className="px-1 py-1 ">
										<Menu.Item>
											<button 
                      onClick={() => {
                        handleShippingSubmit(30);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Shipped
											</button>
										</Menu.Item>
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleShippingSubmit(60);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Delivered
											</button>
										</Menu.Item>
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleMenuClose();
                        handleRejectOpen();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Reject
											</button>
										</Menu.Item>
									</div>
								</Menu.Items>
                  )}
							</Menu>
          </>
          : null}
        {data?.isOrderFulfillment
          ? <>
         	<Menu as="div" className="text-left">
								<div>
									<Menu.Button onClick={(e: any) => setAnchorFullfillmentEl(e.currentTarget)} 
                   className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white bg-${randomColor}`}
                  style={{ backgroundColor: randomColor }}>
                  {libraryElement || null}
									</Menu.Button>
								</div>
                {anchorFullfillmentEl && (
								<Menu.Items className="absolute fixed z-10 bg-white border border-gray-300 rounded shadow-lg w-auto p-1">
									<div className="px-1 py-1 ">
										<Menu.Item>
											<button 
                      onClick={() => {
                        handleFullfillmentSubmit(20);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Packed
											</button>
										</Menu.Item>
                  
									</div>
								</Menu.Items>
                  )}
							</Menu>
          </>
          : null}
     
        {data?.isShipmentEditable || data?.isVendorShipmentEditable
          ? <>
           <Menu as="div" className="relative  text-left w-auto">
								<div>
									<Menu.Button onClick={(e: any) => setAnchorShipmentEl(e.currentTarget)} 
 className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white bg-${randomColor}`}
                  style={{ backgroundColor: randomColor }}>
                  {libraryElement || null}
									</Menu.Button>
								</div>
                {anchorShipmentEl && (
								<Menu.Items className="absolute fixed z-10 bg-white border border-gray-300 rounded shadow-lg w-36 p-1">
									<div className="px-1 py-1 ">
										<Menu.Item>
											<button 
                      onClick={() => {
                        handleShipmentSubmit(30);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Order-picked-up
											</button>
										</Menu.Item>
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleShipmentSubmit(50);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Out-for-delivery
											</button>
										</Menu.Item>
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleShipmentSubmit(60);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Order-delivered
											</button>
										</Menu.Item>
                  {  data?.isVendorShipmentEditable &&
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleRejectOpen();
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Cancel
											</button>
										</Menu.Item>}
									</div>
								</Menu.Items>
                  )}
							</Menu>
          </> : null}
        {data?.isReturnRequestEditble
          ? <>
          	<Menu as="div" className="relative  text-left">
								<div>
									<Menu.Button onClick={(e: any) => setAnchorReturnRequestEl(e.currentTarget)} 
                   className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110  hover:bg-blue-300 duration-300 text-white bg-${randomColor}`}
                  style={{ backgroundColor: randomColor }}>
                  {libraryElement || null}
									</Menu.Button>
								</div>
                {anchorReturnRequestEl && (
								<Menu.Items className="absolute fixed z-10 bg-white border border-gray-300 rounded shadow-lg w-auto p-1">
									<div className="px-1 py-1 ">
										<Menu.Item>
											<button 
                      onClick={() => {
                        handleReturnRequestSubmit(20);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Accepted
											</button>
										</Menu.Item>
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleReturnRequestSubmit(30);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      PickedUp
											</button>
										</Menu.Item>
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleReturnRequestSubmit(40);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Rejected
											</button>
										</Menu.Item>
                    <Menu.Item>
											<button 
                      onClick={() => {
                        handleReturnRequestSubmit(25);
                        handleMenuClose();
                      }}
                       className="p-2 hover:bg-gray-100 ">
											
                      Liquidated
											</button>
										</Menu.Item>
									</div>
								</Menu.Items>
                  )}
							</Menu>
          </> : null}
      </div>
     
    </>
    
  )
}
